import { Box, Container } from "@mui/material";
import { getDetSearchDroners } from "../src/lib/detailedSearchPage";
import { useContext } from "react";
import { LocalizationContext } from "../src/lib/context";
import { GetStaticProps } from "next";
import InspirationsForm from "src/components/Inspirations/InspirationForm/InspirationsForm";
import DronersInfoSection from "src/components/Droners/DronersInfoSection";
import SearchDroners from "src/components/Droners/SearchDroners";

export const getStaticProps: GetStaticProps = async () => {
  const droners = await getDetSearchDroners();
  return {
    props: {
      droners,
    },
    revalidate: 7200,
  };
};

export default function Droners({ droners }: { droners: any[] }) {
  const { localeStrings } = useContext(LocalizationContext);
  const inpirationsLocalizedPageContent = localeStrings.inspirationsPage;
  const bottomInfoTexts = [
    inpirationsLocalizedPageContent.aboutBody1,
    inpirationsLocalizedPageContent.aboutBody2,
    inpirationsLocalizedPageContent.aboutBody3,
    inpirationsLocalizedPageContent.aboutBody4,
    inpirationsLocalizedPageContent.aboutBody5,
  ];

  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #FFFFFF 0%, #f8f8f8 100%)",
      }}
    >
      <Box className="pb-huge" />
      <Container className="flex col gap-normal pb-extra pt-extra" sx={{}}>
        <SearchDroners droners={droners} />
        <InspirationsForm />
      </Container>
      <DronersInfoSection />
    </Box>
  );
}
